import * as Forms from '@rushplay/forms'
import * as I18n from '@rushplay/i18n'
import * as React from 'react'
import * as ThemeUi from 'theme-ui'

import {FieldResponse} from './field-response'
import {getNormalizedTranslationKey} from './get-normalized-translation-key'
import {isFieldRequired} from './is-field-required'

const SCOPE = '#/definitions/PiqBestpaytransferWithdrawal/properties/swiftCode'

// Bank list provided by Bestpaytransfer, options are displayed as-is (not
// translated) while `code` is the value sent to the payment provider.
const OPTIONS = [
  {
    label: 'PayPay銀行 (ジャパンネット銀行 (PayPay Bank)',
    code: 'PayPay銀行 (ジャパンネット銀行 (PayPay Bank):JANEJPJT:0033',
  },
  {label: 'OKB ( 大垣共立銀行 )', code: 'OKB ( 大垣共立銀行 ):OGAKJPJT:0152'},
  {
    label: '北陸銀行 (Hokuriku Bank)',
    code: '北陸銀行 (Hokuriku Bank):RIKBJPJT:0144',
  },
  {
    label: 'auじぶん銀行 (au Jibun Bank)',
    code: 'auじぶん銀行 (au Jibun Bank):JICRJPJT:0039',
  },
  {label: 'Tottori ( 鳥取銀行 )', code: 'Tottori ( 鳥取銀行 ):BIRDJPJZ:0166'},
  {label: 'Yamagata ( 山形銀行 )', code: 'Yamagata ( 山形銀行 ):YAMBJPJT:0122'},
  {label: 'Tohoku ( 東北銀行 )', code: 'Tohoku ( 東北銀行 ):TOHKJPJ1:0124'},
  {
    label: 'Daishi Hokuetsu ( 第四北越銀行 )',
    code: 'Daishi Hokuetsu ( 第四北越銀行 ):DAISJPJT:0140',
  },
  {
    label: 'Shikoku Bank ( 四国銀行 )',
    code: 'Shikoku Bank ( 四国銀行 ):SIKOJPJT:0175',
  },
  {label: 'Oita ( 大分銀行 )', code: 'Oita ( 大分銀行 ):OITAJPJT:0183'},
  {
    label: '青森みちのく銀行 (Aomori Michinoku Bank)',
    code: '青森みちのく銀行 (Aomori Michinoku Bank):AOMBJPJT:0117',
  },
  {
    label: '広島銀行 (Hiroshima Bank)',
    code: '広島銀行 (Hiroshima Bank):HIROJPJT:0169',
  },
  {label: 'Iwate ( 岩手銀行 )', code: 'Iwate ( 岩手銀行 ):BAIWJPJT:0123'},
  {
    label: 'Yamanashi Bank ( 山梨中央銀行 )',
    code: 'Yamanashi Bank ( 山梨中央銀行 ):YCHBJPJT:0142',
  },
  {label: 'Toyama ( 富山銀行 )', code: 'Toyama ( 富山銀行 ):TOYMJPJT:0145'},
  {label: 'Juroku ( 十六銀行 )', code: 'Juroku ( 十六銀行 ):JUROJPJT:0153'},
  {
    label: '鹿児島銀行 (Kagoshima Bank)',
    code: '鹿児島銀行 (Kagoshima Bank):KAGOJPJT:0185',
  },
  {
    label: 'Toho Bank ( 東邦銀行 )',
    code: 'Toho Bank ( 東邦銀行 ):TOHOJPJT:0126',
  },
  {label: 'Hokkoku ( 北國銀行 )', code: 'Hokkoku ( 北國銀行 ):HKOKJPJT:0146'},
  {label: 'Shiga ( 滋賀銀行 )', code: 'Shiga ( 滋賀銀行 ):SIGAJPJT:0157'},
  {
    label: 'Chugoku ( 中国銀行 )',
    code: 'Chugoku ( 中国銀行 ):CHGKJPJZ:0168',
  },
  {label: 'Iyo ( 伊予銀行 )', code: 'Iyo ( 伊予銀行 ):IYOBJPJT:0174'},
  {label: 'Chikuhou ( 筑邦銀行 )', code: 'Chikuhou ( 筑邦銀行 ):CHIHJPJT:0178'},
  {label: 'Saga ( 佐賀銀行 )', code: 'Saga ( 佐賀銀行 ):BKSGJPJT:0179'},
  {label: 'Miyagin ( 宮崎銀行 )', code: 'Miyagin ( 宮崎銀行 ):MIYAJPJT:0184'},
  {label: 'Ryugin ( 琉球銀行 )', code: 'Ryugin ( 琉球銀行 ):RYUBJPJZ:0187'},
  {
    label: '八十二長野銀行 (Hachijuni Nagano Bank)',
    code: '八十二長野銀行 (Hachijuni Nagano Bank):HABKJPJT:0143',
  },
  {
    label: '三井住友銀行 (SMBC - Sumitomo Mitsui Banking Corporation)',
    code:
      '三井住友銀行 (SMBC - Sumitomo Mitsui Banking Corporation):SMBCJPJT:0009',
  },
  {
    label: '福岡銀行 (The Bank of Fukuoka)',
    code: '福岡銀行 (The Bank of Fukuoka):FKBKJPJT:0177',
  },
  {
    label: '東京スター銀行 (Tokyo Star)',
    code: '東京スター銀行 (Tokyo Star):TSBKJPJT:0526',
  },
  {
    label: '埼玉りそな銀行 (Saitama Resona Bank)',
    code: '埼玉りそな銀行 (Saitama Resona Bank):SAIBJPJT:0017',
  },
  {
    label: 'SBI新生銀行 (SBI Shinsei Bank, Limited)',
    code: 'SBI新生銀行 (SBI Shinsei Bank, Limited):LTCBJPJT:0397',
  },
  {label: 'Akita ( 秋田銀行 )', code: 'Akita ( 秋田銀行 ):AKITJPJT:0119'},
  {
    label: 'Joyo Bank ( 常陽銀行 )',
    code: 'Joyo Bank ( 常陽銀行 ):JOYOJPJT:0130',
  },
  {label: 'Fukui ( 福井銀行 )', code: 'Fukui ( 福井銀行 ):FKUIJPJT:0147'},
  {label: 'Nanto ( 南都銀行 )', code: 'Nanto ( 南都銀行 ):NANTJPJT:0162'},
  {
    label: 'Yamaguchi Bank ( 山口銀行 )',
    code: 'Yamaguchi Bank ( 山口銀行 ):YMBKJPJT:0170',
  },
  {
    label: '18 Shinwa ( 親和銀行 )',
    code: '18 Shinwa ( 親和銀行 ):SHWAJPJT:0181',
  },
  {
    label: 'Kitakyushu Bank ( 北九州銀行 )',
    code: 'Kitakyushu Bank ( 北九州銀行 ):KITQJPJZ:0191',
  },
  {
    label: 'Tono Shinkin Bank ( 東濃信用金庫 )',
    code: 'Tono Shinkin Bank ( 東濃信用金庫 ):TOSKJPJ1:1533',
  },
  {
    label: 'スルガ銀行 (Suruga Bank)',
    code: 'スルガ銀行 (Suruga Bank):SRFXJPJT:0150',
  },
  {
    label: '横浜銀行 (Bank of Yokohama)',
    code: '横浜銀行 (Bank of Yokohama):HAMAJPJT:0138',
  },
  {
    label: '三菱UFJ銀行 (MUFG Bank, Ltd)',
    code: '三菱UFJ銀行 (MUFG Bank, Ltd):BOTKJPJT:0005',
  },
  {
    label: 'ソニー銀行 (Sony Bank)',
    code: 'ソニー銀行 (Sony Bank):SNYBJPJT:0035',
  },
  {label: '足利銀行 (Ashikaga)', code: '足利銀行 (Ashikaga):ASIKJPJT:0129'},
  {label: 'Shonai ( 荘内銀行 )', code: 'Shonai ( 荘内銀行 ):SNAIJPJT:0121'},
  {
    label: 'Chibakogyo Bank ( 千葉興業銀行 )',
    code: 'Chibakogyo Bank ( 千葉興業銀行 ):CHIKJPJT:0135',
  },
  {label: 'Shimizu ( 清水銀行 )', code: 'Shimizu ( 清水銀行 ):SMZGJPJT:0151'},
  {
    label: '33 Bank ( 三十三銀行 )',
    code: '33 Bank ( 三十三銀行 ):MIEBJPJT:0154',
  },
  {label: 'Kiyo ( 紀陽銀行 )', code: 'Kiyo ( 紀陽銀行 ):KIYOJPJT:0163'},
  {label: 'Tajima ( 但馬銀行 )', code: 'Tajima ( 但馬銀行 ):TJMAJPJZ:0164'},
  {
    label: 'Hyakujushi ( 百十四銀行 )',
    code: 'Hyakujushi ( 百十四銀行 ):HYAKJPJT:0173',
  },
  {label: 'Higo ( 肥後銀行 )', code: 'Higo ( 肥後銀行 ):HIGOJPJT:0182'},
  {
    label: 'Kyoto Central Shinkin Bank ( 京都中央信用金庫 )',
    code: 'Kyoto Central Shinkin Bank ( 京都中央信用金庫 ):KYSBJPJZ:1611',
  },
  {
    label: 'みんなの銀行 (Minna no Ginko)',
    code: 'みんなの銀行 (Minna no Ginko):MNNGNKJT:0043',
  },
  {
    label: 'さがみ信用金庫 (Sagami Shinkin Bank)',
    code: 'さがみ信用金庫 (Sagami Shinkin Bank):ZENBJPJT:1288',
  },
  {label: '阿波銀行 (Awa Bank)', code: '阿波銀行 (Awa Bank):AWABJPJT:0172'},
  {
    label: '住信SBIネット銀行 (Sumishin SBI Net Bank)',
    code: '住信SBIネット銀行 (Sumishin SBI Net Bank):NTSSJPJT:0038',
  },
  {
    label: '静岡銀行 (Shizuoka Bank)',
    code: '静岡銀行 (Shizuoka Bank):SHIZJPJT:0149',
  },
  {label: 'イオン銀行 (Ion Bank)', code: 'イオン銀行 (Ion Bank):AEONJPJT:0040'},
  {
    label: 'GMOあおぞらネット銀行 (GMO Aosora Net Bank)',
    code: 'GMOあおぞらネット銀行 (GMO Aosora Net Bank):NCBTJPJT:0310',
  },
  {label: '群馬銀行 (Gunma)', code: '群馬銀行 (Gunma):GUMAJPJT:0128'},
  {label: '千葉銀行 (Chiba Bank)', code: '千葉銀行 (Chiba Bank):CHBAJPJT:0134'},
  {label: '七十七銀行 (77 Bank)', code: '七十七銀行 (77 Bank):BOSSJPJT:0125'},
  {label: '山陰合同銀行 (Gogin)', code: '山陰合同銀行 (Gogin):SGBKJPJT:0167'},
  {
    label: '北海道銀行 (Hokkaido Bank)',
    code: '北海道銀行 (Hokkaido Bank):HKDBJPJT:0116',
  },
  {
    label: '筑波銀行 (Kanto Tsukuba Bank)',
    code: '筑波銀行 (Kanto Tsukuba Bank):KGBKJPJT:0131',
  },
  {label: '愛知銀行 (Aichi Bank)', code: '愛知銀行 (Aichi Bank):AICHJPJN:0542'},
  {
    label: '西日本シティ銀行 (Nishi-nippon City Bank)',
    code: '西日本シティ銀行 (Nishi-nippon City Bank):NISIJPJT:0190',
  },
  {
    label: '沖縄銀行 (Okinawa Bank)',
    code: '沖縄銀行 (Okinawa Bank):BOKIJPJZ:0188',
  },
  {label: '百五銀行 (Hyakugo)', code: '百五銀行 (Hyakugo):HYKGJPJT:0155'},
  {
    label: '愛媛銀行 (Ehime Bank)',
    code: '愛媛銀行 (Ehime Bank):HIMEJPJT:0576',
  },
  {
    label: '池田泉州銀行 (Senshu Ikeda)',
    code: '池田泉州銀行 (Senshu Ikeda):BIKEJPJS:0161',
  },
  {
    label: 'ゆうちょ銀行 (Japan Post Bank (Yucho))',
    code: 'ゆうちょ銀行 (Japan Post Bank (Yucho)):JPPSJPJ1:9900',
  },
  {
    label: 'みずほ銀行 (Mizuho Bank)',
    code: 'みずほ銀行 (Mizuho Bank):MHCBJPJT:0001',
  },
  {
    label: 'りそな銀行 (Resona Bank)',
    code: 'りそな銀行 (Resona Bank):DIWAJPJT:0010',
  },
  {
    label: '北都銀行 (Hokuto Bank)',
    code: '北都銀行 (Hokuto Bank):HOKBJPJT:0120',
  },
  {
    label: 'セブン銀行 (Seven Bank)',
    code: 'セブン銀行 (Seven Bank):SVVNJPJJ:0034',
  },
  {
    label: '京都銀行 (Bank of Kyoto)',
    code: '京都銀行 (Bank of Kyoto):BOKFJPJZ:0158',
  },
  {
    label: '関西みらい銀行 (Kansai Mirai Bank)',
    code: '関西みらい銀行 (Kansai Mirai Bank):OSABJPJS:0159',
  },
  {
    label: '武蔵野銀行 (Musashino Bank)',
    code: '武蔵野銀行 (Musashino Bank):MUBKJPJT:0133',
  },
]

/**
 * Component that renders a Select with the available Bestpaytransfer swift
 * codes. Option labels are displayed as provided (not translated), while
 * `code` is the value sent to Bestpaytransfer.
 * @component BestpaytransferSwiftCodeSelect
 * @returns {ReactNode}
 */
export function BestpaytransferSwiftCodeSelect() {
  const field = Forms.useField(SCOPE, {initialValue: OPTIONS[0].code})
  const paymentMethodId = Forms.useField('#/properties/provider', {
    noRegister: true,
  }).value

  const labelKey = getNormalizedTranslationKey(field.label, paymentMethodId)
  const placeholderKey = getNormalizedTranslationKey(
    field.placeholder,
    paymentMethodId
  )
  const schema = Forms.useFormSchema()
  const {theme} = ThemeUi.useThemeUI()
  const required =
    theme.colors?.requiredMarkColor && isFieldRequired(schema, SCOPE)

  const translate = I18n.useTranslate(() => [labelKey, placeholderKey])

  const value = field.value && field.value.toString()

  return (
    <ThemeUi.Grid>
      <ThemeUi.Field
        as={ThemeUi.Select}
        label={
          <>
            {translate(labelKey)}
            {required && (
              <ThemeUi.Text
                as="span"
                sx={{color: 'requiredMarkColor', ml: '4px'}}
              >
                *
              </ThemeUi.Text>
            )}
          </>
        }
        name={field.name}
        placeholder={translate(placeholderKey)}
        value={value}
        onChange={field.onChange}
        onBlur={field.onBlur}
      >
        {OPTIONS.map((option) => (
          <option key={option.code} value={option.code}>
            {option.label}
          </option>
        ))}
      </ThemeUi.Field>
      <FieldResponse scope={SCOPE} />
    </ThemeUi.Grid>
  )
}
